import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RuntimeConfigService } from '../../../services/runtime-config.service';
import { Observable } from 'rxjs';

import { User } from '../../models/user.model';
import { StaffProfile } from './models/StaffProfile';
import { GuardianStudent } from './models/guardian-student.model';

@Injectable({
  providedIn: 'root'
})

export class ProfilesService {
  private apiUrl: string;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private runtimeConfig: RuntimeConfigService) {
    this.apiUrl = this.runtimeConfig.currentConfig.apiUrl;

    // Subscribe to config changes to update apiUrl
    this.runtimeConfig.config$.subscribe(config => {
      this.apiUrl = config.apiUrl;
    });
  }

  updateUserNotificationPrefsAysnc(userProfile: User): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/UserProfile/UpdateUserNotificationPrefsAysnc`, { UserProfile: userProfile });
  }

  updateStaffProfileAysnc(userProfile: User): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/UserProfile/UpdateStaffProfileAysnc`, userProfile);
  }

  updateGuardianProfileAysnc(userProfile: User): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/UserProfile/UpdateGuardianProfileAysnc`, userProfile);
  }

  updateStudentProfileAysnc(userProfile: User): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/UserProfile/UpdateStudentProfileAysnc`, userProfile);
  }

  getStaffBySupervisorIdAsync(userId: number): Observable<User[]> {
    return this.http.get<User[]>(`${this.apiUrl}/UserProfile/GetStaffBySupervisorIdAsync/${userId}`);
  }

  getStaffProfileByUserIdAsync(userId: number): Observable<StaffProfile> {
    return this.http.get<StaffProfile>(`${this.apiUrl}/UserProfile/GetStaffProfileByUserIdAsync/${userId}`);
  }

  getUserProfileByUserIdAsync(userId: number): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/UserProfile/GetUserProfileByUserIdAsync/${userId}`);
  }

  getGuardianStudentDtoByStudentIdAsync(studentId: number): Observable<GuardianStudent[]> {
    return this.http.get<GuardianStudent[]>(`${this.apiUrl}/Student/GetGuardianStudentDtoByStudentIdAsync/${studentId}`);
  }

  getGuardianStudentDtoByGuardianIdAsync(guardianId: number): Observable<GuardianStudent[]> {
    return this.http.get<GuardianStudent[]>(`${this.apiUrl}/Guardian/GetGuardianStudentDtoByGuardianIdAsync/${guardianId}`);
  }

  updateUserImageAsync(formData: FormData): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/UserImage/UpdateUserImageAsync`, formData);
  }

}
